import React from 'react';
import Layout from '../components/Layout';
import DistrictList from '../components/DistrictList';

/**
 * Página de listado de distritos
 * Utiliza el componente Layout para mantener la estructura consistente
 * y el componente DistrictList para mostrar la lista de distritos
 */
const Districts = () => {
  return (
    <Layout>
      <div>
        <DistrictList />
      </div>
    </Layout>
  );
};

export default Districts;
